import Cookie from "./cookie";
import envProps from "./envProps";

class ExperimentSample {
  /**
   * Experiments class,
   * contain basic logic for all experiments.
   * Experiments enable if cookie value more than zero
   * @param options
   */
  constructor(options) {
    if (!options) {
      console && console.error("no Experiment options");
      return;
    }

    this.options = options;
    this.expValue = this._getCookieValue();

    if (this.expValue === "") {
      this.expValue = this._getRandom();
      this._setCookie();
    }
  }

  /**
   * Return experiment`s cookie value
   * @returns {*}
   */
  getValue() {
    return this.expValue;
  }

  /**
   * Set experiment`s cookie value
   * @private
   */
  _setCookie() {
    const name = this.options.name;

    if (!name && window.debug && window.console) {
      window.console.error(
        "Experiment can`t set cookie, because options not is set the name"
      );
    }

    Cookie.set(name, this.expValue.toString(), 30, envProps.cookieDomain);
  }

  /**
   * Return experiment`s cookie value
   * @returns {*}
   * @private
   */
  _getCookieValue() {
    let val = Cookie.get(this.options.name);

    if (val === "") return val;

    val = parseInt(val);

    if (isNaN(val)) return "";

    return val;
  }

  /**
   * Get random value in interval [1, 100]
   * @return number
   * @private
   */
  _getRandom() {
    return Math.floor(Math.random() * 100) + 1;
  }
}

export default ExperimentSample;
